var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import styled from 'styled-components';
import Button from './button';
import Dropdown from './dropdown';
import DropdownItem from './dropdown-item';
var CenterButtonCol = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  align-items: center;\n  display: inline-block;\n  margin-left: auto;\n  @media (max-width: 767px) {\n    visibility: hidden;\n    display: none;\n  }\n"], ["\n  width: 100%;\n  align-items: center;\n  display: inline-block;\n  margin-left: auto;\n  @media (max-width: 767px) {\n    visibility: hidden;\n    display: none;\n  }\n"])));
var DropDownDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  margin: auto;\n  @media (min-width: 768px) {\n    visibility: hidden;\n    display: none;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  margin: auto;\n  @media (min-width: 768px) {\n    visibility: hidden;\n    display: none;\n  }\n"])));
var StyledDropdown = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1em;\n  margin-bottom: 1em;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1em;\n  margin-bottom: 1em;\n"])));
var CenterCol = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var CenteredRow = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"], ["\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"])));
var LeftButton = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: 2em;\n  margin-top: 1em;\n  margin-bottom: 1em;\n"], ["\n  margin-left: auto;\n  margin-right: 2em;\n  margin-top: 1em;\n  margin-bottom: 1em;\n"])));

var ButtonCarousel =
/** @class */
function (_super) {
  __extends(ButtonCarousel, _super);

  function ButtonCarousel(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = function (index) {
      var components = _this.props.components;
      var buttonArray = new Array();
      components.forEach(function (_element, i) {
        buttonArray.push(i === index);
      });

      _this.setState(__assign(__assign({}, _this.state), {
        showComponent: buttonArray
      }));
    };

    _this.getDisplayComponent = function () {
      var components = _this.props.components;

      if (_this.state.showButtons && _this.state.showComponent.indexOf(true) >= 0) {
        return React.createElement(CenterCol, {
          className: "col-12"
        }, components[_this.state.showComponent.indexOf(true)]);
      } else {
        return React.createElement(CenterCol, {
          className: "col-12"
        }, components[0]);
      }
    };

    _this.getButtonList = function () {
      var _a = _this.props,
          componentDisplayNames = _a.componentDisplayNames,
          defaultDropdownText = _a.defaultDropdownText;

      if (_this.state.showButtons) {
        return React.createElement(React.Fragment, null, React.createElement(CenterButtonCol, {
          className: "col-12"
        }, componentDisplayNames.map(function (element, i) {
          return React.createElement(LeftButton, {
            brand: "primary",
            invert: _this.state.showComponent[i],
            onClick: function onClick() {
              return _this.handleClick(i);
            }
          }, element);
        })), React.createElement(DropDownDiv, null, React.createElement(StyledDropdown, null, React.createElement(Dropdown, {
          brand: "primary",
          header: defaultDropdownText || 'Select an option',
          onSelect: function onSelect(e) {
            return _this.handleClick(parseInt(e));
          }
        }, componentDisplayNames.map(function (element, i) {
          return React.createElement(DropdownItem, {
            value: i.toString()
          }, element);
        })))));
      } else {
        return React.createElement(React.Fragment, null);
      }
    };

    _this.state = {
      showComponent: new Array(),
      showButtons: false
    };
    return _this;
  }

  ButtonCarousel.prototype.componentDidMount = function () {
    var _a = this.props,
        components = _a.components,
        componentDisplayNames = _a.componentDisplayNames;

    if (components.length !== componentDisplayNames.length) {//Don't be dumb
    } else if (components.length === 0) {//Just don't
    }

    if (components.length === 1) {
      //No buttons required
      var buttonArray = new Array(true);
      this.setState(__assign(__assign({}, this.state), {
        showButtons: false,
        showComponent: buttonArray
      }));
    } else {
      var buttonArray_1 = new Array();
      components.forEach(function (_element, i) {
        buttonArray_1.push(i === 0);
      });
      this.setState(__assign(__assign({}, this.state), {
        showButtons: true,
        showComponent: buttonArray_1
      }));
    }
  };

  ButtonCarousel.prototype.render = function () {
    return React.createElement(CenteredRow, {
      className: "row"
    }, this.props.buttonLocation === 1 && this.getButtonList(), this.getDisplayComponent(), (this.props.buttonLocation === undefined || this.props.buttonLocation === 0) && this.getButtonList());
  };

  return ButtonCarousel;
}(Component);

export default ButtonCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;